import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from 'react-dom/client';

// Minimal polyfill to avoid runtime errors on environments lacking Intl.DisplayNames (e.g., react-snap's Chromium).
if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames !== 'function') {
  Intl.DisplayNames = function IntlDisplayNames() {
    return { of: (value) => value };
  };
}
const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
